import "../Styles/sidebar.css";
import logoImg from "../../SVG/LogoCenfotec.svg";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import authService from "../../services/authService";
import RolesConfig from "../../config/Roles";
import { getAdminSidebarPage } from "../../Api/content";
import { useLocale } from "../../i18n/localeContext";
import { useState, useEffect, useMemo } from "react";

// Desplegar menu de configuracion y de usuario
const optionMenuT = (e) => {
  const optionMenu = document.querySelector(".optionMenu");
  const toggleBtn = document.getElementById("showConfigIcon");
  optionMenu.classList.toggle("unhidden");
  toggleBtn.classList.toggle("rotate");
};

const optionReportesT = (e) => {
  const optionMenu = document.querySelector(".optionReportes");
  const toggleBtn = document.getElementById("showReportesIcon");
  optionMenu.classList.toggle("unhidden");
  toggleBtn.classList.toggle("rotate");
};

const optionCamposT = (e) => {
  const optionMenu = document.querySelector(".optionCampos");
  const toggleBtn = document.getElementById("showCampoIcon");
  optionMenu.classList.toggle("unhidden");
  toggleBtn.classList.toggle("rotate");
};

const hideSidebar = () => {
  const sidebar = document.querySelector(".sideBar");
  sidebar.classList.toggle("sideBarVisible");

  const closeBtn = document.querySelectorAll(".toggleBtnAdm");
  closeBtn.forEach((el) => {
    el.classList.toggle("invisibleBtn");
  });
};

function SideBar(props) {
  const { locale } = useLocale();
  const [adminSidebarPage, setAdminSidebarPage] = useState(null);
  const navigate = useNavigate();
  const { hasPermission } = props;

  useEffect(() => {
    let cancel = false;
    getAdminSidebarPage(locale)
      .then((res) => {
        const data = res?.data?.attributes || res?.data || res;
        if (!cancel) setAdminSidebarPage(data);
      })
      .catch(() => { if (!cancel) setAdminSidebarPage(null) });
    return () => { cancel = true };
  }, [locale])

  const menuPrincipal = useMemo(() => ([
    {
      optionId: "1",
      option: adminSidebarPage?.home_sb || "Inicio",
      path: "/Admin",
      icon: "",
    },
    {
      optionId: "2",
      option: adminSidebarPage?.application_sb || "Administración de solicitudes",
      path: "solicitudes",
      icon: "",
    },
    {
      optionId: "3",
      option: adminSidebarPage?.document_sb || "Documentos",
      path: "listaArchivos",
      icon: "",
    },
    {
      optionId: "4",
      option: adminSidebarPage?.sponsor_sb || "Asignación de becas y patrocinios",
      path: "listaBecasPatrocinios",
      icon: "",
    },
  ]), [adminSidebarPage]);

  const optionArray = useMemo(() => ([
    { optionId: "1", option: adminSidebarPage?.translation_sb || "Traducciones", path: "traducciones" },
    { optionId: "2", option: adminSidebarPage?.ofert_sb || "Carreras a ofertar", path: "carreras" },
    { optionId: "3", option: adminSidebarPage?.educenter_sb || "Centros educativos", path: "centros" },
    { optionId: "4", option: adminSidebarPage?.generalsetting_sb || "Configuraciones generales", path: "configGeneral" },
    { optionId: "5", option: adminSidebarPage?.profiledefi_sb || "Definición de perfiles", path: "perfiles" },
    { optionId: "6", option: adminSidebarPage?.academiclevel_sb || "Niveles academicos", path: "niveles" },
    { optionId: "7", option: adminSidebarPage?.profileparam_sb || "Perfil parámetros", path: "perfilesParametros" },
    { optionId: "8", option: adminSidebarPage?.template_sb || "Plantillas", path: "plantillas" },
    { optionId: "9", option: adminSidebarPage?.templatetype_sb || "Tipos plantillas", path: "plantillasTipos" },
    { optionId: "10", option: adminSidebarPage?.user_sb || "Usuarios", path: "usuarios" },
  ]), [adminSidebarPage]);

  const rutasReportes = useMemo(() => ([
    { optionId: "15", option: adminSidebarPage?.erollstudent_sb || "Estudiantes matriculados", path: "estudiantesMatriculados" },
    { optionId: "16", option: adminSidebarPage?.studentasistence_sb || "Estudiantes con asistencia", path: "estudiantesAsistencia" },
    { optionId: "10", option: adminSidebarPage?.studentpending_sb || "Estudiantes con doc. pendientes", path: "docPendientes" },
  ]), [adminSidebarPage]);

  const campos = useMemo(() => ([
    { optionId: "10", option: adminSidebarPage?.wayknow_sb || "Formas de conocernos", path: "formas" },
    { optionId: "11", option: adminSidebarPage?.period_sb || "Períodos", path: "periodos" },
    { optionId: "12", option: adminSidebarPage?.periodtype_sb || "Tipos periodos", path: "tiposPeriodos" },
    { optionId: "13", option: adminSidebarPage?.reason_sb || "Razones", path: "razones" },
    { optionId: "14", option: adminSidebarPage?.financialtype_sb || "Tipos de financiamientos", path: "tiposFinanciamientos" },
    { optionId: "15", option: adminSidebarPage?.orgtype_sb || "Tipos de organizaciones", path: "tiposOrganizaciones" },
    { optionId: "16", option: adminSidebarPage?.place_sb || "Lugares", path: "lugares" },
    { optionId: "17", option: adminSidebarPage?.documenttype_sb || "Tipos de Documentos", path: "perfilesDocumentosTipos" },
  ]), [adminSidebarPage]);

  return (
    <div className="sideBar">
      <div className="image-container">
        <img src={logoImg} className="logo" alt="Logo CENFOTEC"></img>
      </div>
      <div style={{ overflowY: "auto", maxHeight: "80vh" }}>
        {menuPrincipal.map((op) => (
          <Link
            key={op.optionId}
            to={op.path}
            onClick={() => {
              hideSidebar();
            }}
          >
            <i className="material-icons">{op.icon}</i>
            <span>{op.option}</span>
          </Link>
        ))}

        <button className="btnConfig" onClick={optionReportesT}>
          <i className="material-icons"></i>{adminSidebarPage?.report_sb || "Reportes"}
          <i className="material-icons showOptions" id="showReportesIcon">
            
          </i>
        </button>
        <div className="optionReportes">
          {rutasReportes.map((item, i) => {
            return (
              <Link
                key={i}
                to={item.path}
                onClick={() => {
                  hideSidebar();
                }}
              >
                {item.option}
              </Link>
            );
          })}
        </div>
        {hasPermission && (
          <>
            <button className="btnConfig" onClick={optionMenuT}>
              <i className="material-icons"></i>{adminSidebarPage?.setting_sb || "Configuración"}
              <i className="material-icons showOptions" id="showConfigIcon">
                
              </i>
            </button>
            <div className="optionMenu">
              {optionArray.map((item, i) => {
                return (
                  <Link
                    key={i}
                    to={item.path}
                    onClick={() => {
                      hideSidebar();
                    }}
                  >
                    {item.option}
                  </Link>
                );
              })}
              <button className="btnCampos" onClick={optionCamposT}>
                {adminSidebarPage?.field_sb || "Campos"}
                <i className="material-icons showOptions" id="showCampoIcon">
                  
                </i>
              </button>
              <div className="optionCampos">
                {campos.map((item, i) => {
                  return (
                    <Link
                      key={i}
                      to={item.path}
                      onClick={() => {
                        hideSidebar();
                      }}
                    >
                      {item.option}
                    </Link>
                  );
                })}
              </div>
            </div>
          </>
        )}

        <button
          id="btn-cerrar-sesion"
          className="invisibleCerrarSesion"
          onClick={() => {
            authService.logout(navigate);
          }}
        >
          {adminSidebarPage?.logout_sb || "Cerrar sesión"}<i className="material-icons"></i>
        </button>
      </div>
    </div>
  );
}

export default SideBar;
